module.exports = __webpack_public_path__ + "static/media/Cup_small.4d630145.png";